import type { FC, SVGProps } from 'react';

/**
 * Planning product icon — verbatim from the legacy
 * `wf-audit/src/slices/common/components/icons/PlanningIcon.tsx`.
 */
const PlanningIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <path
      d="M17.5526 7.35352V14.8095M45.6553 7.35352V14.8095M9.80469 21.9684V19.006C9.80469 14.9107 13.0972 11.5908 17.1587 11.5908H46.5746C50.636 11.5908 53.9285 14.9107 53.9285 19.006V21.9684M9.80469 21.9684V49.3733C9.80469 53.4686 13.0972 56.7886 17.1587 56.7886H46.5746C50.636 56.7886 53.9285 53.4686 53.9285 49.3733V21.9684M9.80469 21.9684H53.9285"
      stroke="var(--brand-blue)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.8373 45.6812C27.8373 44.4402 28.8475 43.4342 30.0936 43.4342H31.7142C32.9604 43.4342 33.9706 44.4402 33.9706 45.6812V47.2952C33.9706 48.5362 32.9604 49.5422 31.7142 49.5422H30.0936C28.8475 49.5422 27.8373 48.5362 27.8373 47.2952V45.6812Z"
      fill="var(--brand-yellow)"
    />
    <path
      d="M41.3753 31.8193C41.3753 30.5783 42.3855 29.5723 43.6316 29.5723H45.2522C46.4984 29.5723 47.5086 30.5783 47.5086 31.8193V33.4333C47.5086 34.6743 46.4984 35.6803 45.2522 35.6803H43.6316C42.3855 35.6803 41.3753 34.6743 41.3753 33.4333V31.8193Z"
      fill="var(--brand-yellow)"
    />
    <path
      d="M16.4648 45.6812C16.4648 44.4402 17.475 43.4342 18.7212 43.4342H20.3418C21.588 43.4342 22.5981 44.4402 22.5981 45.6812V47.2952C22.5981 48.5362 21.588 49.5422 20.3418 49.5422H18.7212C17.475 49.5422 16.4648 48.5362 16.4648 47.2952V45.6812Z"
      fill="var(--brand-yellow)"
    />
    <path
      d="M30.0028 31.8193C30.0028 30.5783 31.013 29.5723 32.2592 29.5723H33.8798C35.1259 29.5723 36.1361 30.5783 36.1361 31.8193V33.4333C36.1361 34.6743 35.1259 35.6803 33.8798 35.6803H32.2592C31.013 35.6803 30.0028 34.6743 30.0028 33.4333V31.8193Z"
      fill="var(--brand-yellow)"
    />
  </svg>
);

export default PlanningIcon;
